// extracted by mini-css-extract-plugin
export var fontBold = "_s8fsxLbGAGDfdrlh7ZP";
export var fontMedium = "HIifnr_FCB03NJ3YmxQ3";
export var fontRegular = "oci5FMpUKXOEbGTrbq4E";
export var fontSemiBold = "S_THuSyGDT3D5Nq9DF1J";